import logo from './logo.svg';
import './App.css';
import Home from './pages/home/Home';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import { Route, Switch } from 'react-router-dom';
import SignUp from './components/sign-up/SignUp';
import { AppProvider, useAppContext } from './app-context';
import Constants from './constants';
import Sidebar from './components/sidebar/Sidebar';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Profile from './pages/profile/Profile';
import { ProfileProvider } from './pages/profile/profile-context';
import { ConnectionsProvider } from './pages/connections/connections-context';
import Connections from './pages/connections/Connections';

function App() {
  const { sidebarOpen } = useAppContext();
  return (
    <div className='App'>
      <TransitionGroup>
        {sidebarOpen && (
          <CSSTransition classNames='transition' timeout={300}>
            <Sidebar className='app-sidebar' />
          </CSSTransition>
        )}
      </TransitionGroup>
      {!sidebarOpen && (
        <main className='container-wrap'>
          <section className='navbar'>
            <Navbar />
          </section>
          <Switch>
            <Route exact path={Constants.HOME_PAGE_ROUTE}>
              <Home />
            </Route>
            <Route path={Constants.SIGNUP_PAGE_ROUTE}>
              <SignUp />
            </Route>
            <Route path={Constants.PROFILE_PAGE_ROUTE}>
              <ProfileProvider>
                <Profile />
              </ProfileProvider>
            </Route>
            <Route path={Constants.CONNECTIONS_PAGE_ROUTE}>
              <ConnectionsProvider>
                <Connections />
              </ConnectionsProvider>
            </Route>
          </Switch>
        </main>
      )}
      {!sidebarOpen && <Footer />}
    </div>
  );
}

export default App;
